const products = [
    { brand: "Solis", logo: "../images/products/solis.png" },
    { brand: "Growatt", logo: "../images/products/growatt.png" },
    { brand: "FIMER", logo: "../images/products/fimer.png" },
    { brand: "Afore", logo: "../images/products/afore.png" },
    { brand: "SMA", logo: "../images/products/sma.jpg" },
    { brand: "GoodWe", logo: "../images/products/Goodwe.png" },
    { brand: "Deye", logo: "../images/products/Deye.png" },
    { brand: "Huawei", logo: "../images/products/Huawei.png" },
    { brand: "SolaX Power", logo: "../images/products/Solax.png" },
    { brand: "Jinko Solar", logo: "../images/products/Jinko.png" },
    { brand: "LONGi Solar", logo: "../images/products/Longi.png" },
    { brand: "Canadian Solar", logo: "../images/products/Canadian.png" },
    { brand: "JA Solar", logo: "../images/products/JA.png" },
    { brand: "Phono Solar", logo: "../images/products/Phono.png" },
    { brand: "Trina Solar", logo: "../images/products/Trina.png" },
    { brand: "REC", logo: "../images/products/REC.png" },
    { brand: "LAPP KABEL", logo: "../images/products/LAPP.png" },
    { brand: "KBE Berlin", logo: "../images/products/KBE.png" },
    { brand: "Kelani Cables", logo: "../images/products/Kelani.png" },
    { brand: "ACL Cables", logo: "../images/products/ACL.jpg" },
    { brand: "ZBeny", logo: "../images/products/Beny.jpg" },
    { brand: "ABB", logo: "../images/products/ABB.jpg" },
    { brand: "Schneider Electric", logo: "../images/products/Schneider.png" },
    { brand: "Phoenix Contact", logo: "../images/products/Phoenix.png" },
    { brand: "Swisstek", logo: "../images/products/Swisstek.png" }
];

export default products;
